import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — site-wide route-change scroll reset.
 *
 * React Router does NOT auto-scroll to top on client-side navigation. Without
 * this, clicking from the homepage to /leak-check leaves you at the same
 * y-offset you were at on the previous page — looks broken on mobile and
 * desktop. Mount this once inside <BrowserRouter> at app root.
 *
 * Behaviour:
 *  - On pathname change, scroll window to (0, 0) using 'instant' so it doesn't
 *    create a long scroll animation that competes with the page's own
 *    entrance animations.
 *  - Preserve in-page hash scrolling (e.g. `/#results`): if a hash is present
 *    the browser/router will handle the anchor jump, so we skip the reset.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let the browser jump to the anchor instead
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
